import { MdOutlineCheck } from "react-icons/md";

import { formatToPersianClock, formatToPersianDate } from "../../../../utils";
import PersianNumber from "../../../../utils/PersianNumber/PersianNumber";

const CustomerLivePcView = ({ getLiveOrders }) => {
  //* Table Title
  const tableTitle = [
    { id: 1, title: "#" },
    { id: 2, title: "شماره سفارش" },
    { id: 3, title: "نام محصول" },
    { id: 4, title: "وضعیت" },
    { id: 5, title: "حجم" },
    { id: 6, title: "قیمت" },
    { id: 7, title: "مبلغ" },
    { id: 8, title: "توضیحات" },
    { id: 9, title: "اردری" },
    { id: 10, title: "تاریخ" },
  ];

  return (
    <>
      {/* Table */}
      <div
        className="mt-8 w-full flex justify-end items-center
      animate__animated animate__fadeIn animate__slow"
      >
        <table className="w-full 2xl:w-[95%] xl:w-[93%] lg:w-[90%]">
          {/* Table Header */}
          <thead className="text-sm font-medium text-slate-200 border-b-[1px] border-boxColor">
            <tr>
              {tableTitle.map((_item) => (
                <th key={_item?.id} className="py-3 pr-3">
                  <div>{_item?.title}</div>
                </th>
              ))}
            </tr>
          </thead>
          {/* Table Body */}
          <tbody className="text-lg divide-y divide-boxColor w-full">
            {getLiveOrders?.map((_item, index) => (
              <tr
                key={_item.id}
                className="hover:bg-boxColor w-full relative h-20"
              >
                {/* Number */}
                <td className="py-4 px-3">
                  <div
                    className="flex items-center justify-center 
                                  font-medium text-slate-200 text-base text-center
                                  animate__animated animate__fadeIn animate__fast"
                  >
                    {index + 1}
                  </div>
                </td>
                {/* Transaction ID */}
                <td className="py-4">
                  <span className="flex justify-center items-center text-gray-100 w-full md:text-sm text-xs">
                    #{_item?.transaction_id}
                  </span>
                </td>
                {/* Product Name */}
                <td className="py-4">
                  <div className="text-center font-medium text-sm text-gray-100">
                    <span>معامله </span>
                    <span
                      className={`${
                        _item?.bos === "B" ? "text-[#00FF00]" : "text-[#FF073A]"
                      }`}
                    >
                      {_item?.bos === "B" ? "خرید" : "فروش"}{" "}
                    </span>
                    <span>{_item?.product_name}</span>
                  </div>
                </td>
                {/* Order Status */}
                <td className="py-4">
                  <span className="w-full flex justify-center items-center md:text-sm text-xs font-medium text-center">
                    {_item?.tType === "T" && (
                      <span className="text-[#00FF00] cursor-pointer">
                        تأیید شده
                      </span>
                    )}
                    {_item?.tType === "L" && (
                      <>
                        <span className="text-[#FF073A] cursor-pointer">
                          لغو شده
                        </span>
                      </>
                    )}
                  </span>
                </td>
                {/* Weight */}
                <td className="py-4">
                  <span className="flex justify-center items-center text-gray-100 w-full md:text-base text-sm">
                    {_item.volume}
                    <p className="text-[#00BFFF] px-1 text-xs">
                      {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"}
                    </p>
                  </span>
                </td>
                {/* Price */}
                <td className="py-4">
                  <span className="flex justify-center items-center text-gray-100 w-full md:text-base text-sm">
                    <PersianNumber value={_item.price} thousandSeparator="," />
                    <p className="px-1 text-xs text-[#00BFFF] text-center">
                      تومان
                    </p>
                  </span>
                </td>
                {/* Total */}
                <td className="py-4">
                  <span className="flex justify-center items-center text-gray-100 w-full md:text-base text-sm">
                    <PersianNumber value={_item.amount} thousandSeparator="," />
                    <p className="px-1 text-xs text-[#00BFFF] text-center">
                      تومان
                    </p>
                  </span>
                </td>
                {/* Description */}
                <td className="py-4">
                  <span className="flex justify-center items-center text-gray-100 text-sm w-full">
                    <span
                      className="flex justify-end items-center px-1
                        w-32 overflow-hidden text-ellipsis whitespace-nowrap"
                    >
                      {_item?.description ? (
                        _item?.description
                      ) : (
                        <span className="flex justify-center items-center w-full">
                          -
                        </span>
                      )}
                    </span>
                  </span>
                </td>
                {/* Ordery Status */}
                <td className="py-4">
                  <span className="w-full flex justify-center items-center">
                    {_item?.is_orderi ? (
                      <MdOutlineCheck size={26} fill="#00BFFF" />
                    ) : (
                      <span className="text-slate-300">-</span>
                    )}
                  </span>
                </td>
                {/* Date */}
                <td className="py-4 px-3">
                  <span className="w-full flex justify-center items-center font-medium md:text-sm text-xs text-gray-100">
                    <span>{formatToPersianClock(_item?.date_create)}</span>
                    <span className="mx-3">-</span>
                    <span>{formatToPersianDate(_item?.date_create)}</span>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CustomerLivePcView;
